export function popoverInit() {
    const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    const popoverList = popoverTriggerList.map(async (popoverTriggerEl) => {
        const {default: Popover} = await import('bootstrap/js/dist/popover');
        return new Popover(popoverTriggerEl, {});
    });
}